import FeatureFlagsStore from '@/V2/stores/FeatureFlagsStore';

export function getUseAllDocsQueryParameter(params) {
  const creditReconciledDocsFilterDefaultValue =
    FeatureFlagsStore.getters.creditReconciledDocsFilterDefaultValue(
      FeatureFlagsStore.state,
    );
  return getQueryParameter({
    params: params,
    name: 'use_all_docs',
    defaultValue: creditReconciledDocsFilterDefaultValue,
  });
}

export function getQueryParameter({ params, name, defaultValue = '' }) {
  return params && params[name] !== undefined ? params[name] : defaultValue;
}
